import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

import {
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              ABOUT <span className="purple"> ME </span>
            </h1>
            <p className="home-about-body" style={{ textAlign: "justify" }}>
              I’m <b className="purple">Amr Medhat Amer</b>, a Cloud Engineer and Computer Science student specializing in <b className="purple">Cybersecurity</b> at Alexandria University.
              <br />
              <br />
              I’ve worked as a <b className="purple">Cloud Engineer Intern</b> at <b>Verizon and Google Cloud</b>, where I deployed cloud infrastructure, automated CI/CD pipelines, and built secure cloud solutions.
              <br />
              <br />
              My expertise spans across <b className="purple">Azure, AWS, GCP</b>, and tools like <b className="purple">Terraform, GitHub Actions, Jenkins, Docker and Kubernetes</b>. I hold multiple certifications in Azure administration and security.
              <br />
              <br />
              I’m passionate about <b className="purple">cloud architecture, DevOps practices, and identity & access management</b>. Outside tech, I enjoy writing tech blogs, gaming, and traveling to explore new cultures.
              <br />
              <br />
              <b className="purple">Countries I've visited:</b>{" "}
              <img src="https://flagcdn.com/w40/sa.png" alt="Saudi Arabia" width="20" style={{ marginLeft: "5px" }} />
              <img src="https://flagcdn.com/w40/tr.png" alt="Turkey" width="20" style={{ marginLeft: "5px" }} />
              <img src="https://flagcdn.com/w40/dk.png" alt="Denmark" width="20" style={{ marginLeft: "5px" }} />
              <img src="https://flagcdn.com/w40/gb.png" alt="England" width="20" style={{ marginLeft: "5px" }} />
              <br />
              <br />
              <span style={{ color: "rgb(155 126 172)", fontStyle: "italic" }}>
                "Strive to build things that make a difference!"
              </span>{" "}
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/amrmamer/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/amrrmedhattt/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
